import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("../views/home/index")
    },
    {
        path: "/chat",
        name: 'chat',
        component: () => import("../views/chat/index.vue")
    },

    {
        path: '/advanceBatch',
        name: 'advanceBatch',
        component: () => import('../views/advanceBatch/index.vue')
    },

    {
        path: '/search',
        name: 'search',
        component: () => import('../views/home/search.vue')
    },
    {
        path: "/Login",
        name: "Login",
        component: () => import("../views/login/index")
    },
    {
        path: "/Register",
        name: "Register",
        component: () => import("../views/Register")
    },
    {
        path: "/help",
        name: "help",
        component: () => import("../views/help")
    },
    //个人信息
    {
        path: '/information',
        name: 'information',
        component: () => import('../views/user/Information.vue')
    },
    //个人中心
    {
        path: '/User',
        component: () => import('../views/user'),
        children: [
            {
                path: 'info',
                name: 'info',
                meta: '个人资料',
                component: () => import('../views/user/Info.vue')
            },

            {
                path: 'myAssess',
                name: 'myAssess',
                meta: '我的测评',
                component: () => import('../views/user/MyAssess.vue')
            },

            {
                path: 'myCard',
                name: 'myCard',
                meta: '我的会员卡',
                component: () => import('../views/user/MyCard.vue')
            },
            {
                path: 'review',
                name: 'review',
                component: () => import('../views/review/index.vue')
            },
            {
                path: 'ChangePwd',
                name: 'ChangePwd',
                meta: '修改密码',
                component: () => import('../views/user/ChangePwd.vue')
            },
        ]
    },
    {
        path: "/NewsList",
        name: "NewsList",
        meta: {
            keepAlive: true // 需要缓存
        },
        component: () =>
            import("../views/news/NewsList")
    },
    {
        path: "/Detail",
        name: "Detail",
        component: () =>
            import("../views/news/Detail")
    },
    {
        path: "/lookSpecialty",
        name: "lookSpecialty",
        meta: {
            keepAlive: true // 需要缓存
        },
        component: () =>
            import("../views/specialty/look-specialty")
    },
    {
        path: '/specialtyInfo',
        name: 'specialtyInfo',
        component: () => import('../views/specialty/specialtyInfo.vue')
    },
    {
        path: "/lookCollege",
        name: "lookCollege",
        component: () => import("../views/college/look-college")
    },
    {
        path: "/College",
        component: () => import("../views/college/index"),
        children: [
            {
                path: "",
                name: "CollegeInfo",
                component: () => import("../views/college/Info"),
            },
            {
                path: '/solution',
                name: 'solution',
                meta: '招生简章详情',
                component: () => import('../views/college/solution.vue')
            },
            {
                path: "score",
                name: "score",
                component: () => import("../views/college/score"),
            },
            {
                path: "score-other",
                name: "score-other",
                component: () => import("../views/college/score-other"),
            },
            {
                path: "specialty",
                name: "specialty",
                component: () => import("../views/college/specialty"),
            },


        ]
    },

    {
        path: '/newChooseSubject',
        component: () => import("../views/new-choose-subject/index"),
        children: [
            {
                path: "",
                name: 'newChooseSubject',
                component: () => import("../views/new-choose-subject/overview"),
            },

            {
                path: "newSpecialtySearch",
                name: 'newSpecialtySearch',
                component: () => import("../views/new-choose-subject/search"),
            },

            {
                path: "chooseSpecialty",
                component: () => import("../views/new-choose-subject/choose-specialty/index"),
                children: [
                    {
                        path: "",
                        name: 'chooseSpecialty',
                        component: () => import("../views/new-choose-subject/choose-specialty/scheme"),
                    },
                    {
                        path: "analyse",
                        name: 'analyse',
                        component: () => import("../views/new-choose-subject/choose-specialty/analyse"),
                    },
                ]
            },
            {
                path: "newSubjectUser",
                name: 'newSubjectUser',
                component: () => import("../views/new-choose-subject/user/index"),

            },
        ],

    },
    {
        path: '/provinceLine',
        name: 'provinceLine',
        meta: {
            // keepAlive: true // 需要缓存
        },
        component: () => import('../views/score/provinceLine.vue')
    },
    {
        path: '/ranking',
        name: 'ranking',
        component: () => import('../views/score/ranking.vue')
    },
    {
        path: "/Recommend",
        name: "Recommend",
        component: () => import("../views/recommend/Index")
    },
    {
        path: "/download",
        name: "download",
        component: () => import("../views/volunteer/download")
    },
    {
        path: "/volunteer",
        component: () => import("../views/volunteer/Index"),
        children: [
            {
                path: "",
                name: "CollegeFirst",
                component: () => import("../views/volunteer/CollegeFirst"),
            },
            {
                path: "ReportTable",
                name: "ReportTable",
                component: () => import("../views/volunteer/ReportTable"),
            },
            {
                path: "MajorFirst",
                name: "MajorFirst",
                component: () => import("../views/volunteer/MajorFirst"),
            },
        ]
    },
    
    {
        path: "/hld",
        name: "hld",
        component: () => import("../views/assess/hld")
    },
    {
        path: "/hldResult",
        name: "hldResult",
        component: () => import("../views/assess/hldResult")
    },

    {
        path: '/artCollege',
        name: 'artCollege',
        component: () => import('../views/art/college/index.vue')
    },
    //服务商品
    {
        path: '/server',
        name: 'server',
        meta: {
            // keepAlive: true // 需要缓存
        },
        component: () => import('../views/server/index.vue')
    },
    {
        path: '/goodsInfo',
        name: 'goodsInfo',
        component: () => import('../views/server/goodsInfo.vue')
    },
    {
        path: '/vip',
        name: 'vip',
        component: () => import('../views/server/vip.vue')
    },

    //数据看板
    {
        path: '/lookData',
        name: 'lookData',
        component: () => import('../views/look-data/index.vue')
    },
];
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
